import { Id, Tag } from "@planzone/dto";
import { HttpClient, HttpMethods } from "@planzone/services";
import { LinkedTask } from "../linkers/types";

function addTagToEvent(httpClient: HttpClient) {
  return (tag: Tag, eventId: Id) =>
    httpClient
      .sendHttpRequest<LinkedTask>({
        endpoint: `/events/${eventId}`,
        method: HttpMethods.GET,
      })
      .then((event) =>
        httpClient.sendHttpRequest<void>({
          endpoint: `/events/${eventId}`,
          method: HttpMethods.PATCH,
          data: { tags: [...event.tags, tag.name] },
        }),
      );
}

export { addTagToEvent };
